import React from 'react';
import { isNotUndefined } from 'infrastructure/functions';
import common from 'constants/common';
import BaseTag from 'components/atoms/base-tag';

import s from './styles.module.scss';

import type { RpmStatuses } from 'infrastructure/enums';

interface IProps {
  status: RpmStatuses;
}

const RpmStatus: React.FC<IProps> = ({ status }) => {
  const statusKey = status as keyof typeof common.statusPatients | undefined;

  const statusItem = isNotUndefined(statusKey)
    ? common.statusPatients[statusKey]
    : undefined;

  return (
    <BaseTag
      className={s.tag}
      data-cy="patientTable-rpmStatus"
      size="large"
      color={statusItem?.color}
      label={statusItem?.label}
    />
  );
};

export default RpmStatus;
